<template>
  <a :href="href">
    <span class="icon">
      <span class="fa-stack fa-2x">
        <i class="fas fa-square fa-stack-2x"></i>
        <i class="fas fa-arrow-right fa-stack-1x fa-inverse"></i>
      </span>
    </span>
    <span>{{ label }}</span>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #001A70;
  font-weight: bold;
  display: flex;
  align-items: center;

  .icon {
    font-size: 25%;
    color: #E74281;
  }
}
</style>
